import React from "react";
import { makeStyles } from "@mui/styles";
import Breadcrumb from "../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../App/State/Slices/SelectedCareersClientSlice";
import TabbedView from "../../App/Components/TabbedView/TabbedView";
import FloatingSearchFormPage from "./Components/Tabs/FloatingSearchForm/FloatingSearchFormPage";
import StaticSearchFormPage from "./Components/Tabs/StaticSearchForm/StaticSearchFormPage";
import MapSearchFormPage from "./Components/Tabs/MapSearchForm/MapSearchFormPage";

function FormsPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    autocomplete: {
      width: "35%",
      paddingBottom: "20px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);

  const tabs = [
    { title: "Floating", component: <FloatingSearchFormPage /> },
    { title: "Static", component: <StaticSearchFormPage /> },
    { title: "Map", component: <MapSearchFormPage /> },
  ];

  return (
    <>
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">{selectCareersClient.shortName} Display</h1>
        <div className={classes.root}>
          <TabbedView tabs={tabs} />
        </div>
      </div>
    </>
  );
}

export default FormsPage;
